var _ = require('../util')

_.extend(exports, require('./compile'))
_.extend(exports, require('./transclude'))


/*****************
 ** WEBPACK FOOTER
 ** ./src/compiler/index.js
 ** module id = 10
 ** module chunks = 0
 **/